import './shareable_social_icons.less';

import $ from 'jquery';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  FacebookIcon,
  TwitterIcon,
  LinkedInIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';


class ShareableSocialIcon extends Component {

  render() {
    return (
      <span 
        className={classNames('shareable-social-icon', this.props.className)}
        onClick={()=>{this.handleClick();}}
      >
        {this.props.children}
      </span>
    );
  }
  
  handleClick() {
    var height = 600;
    var width = 540;
    var toppx = ($(window).height() / 2) - (height / 2);
    var leftpx = ($(window).width() / 2) - (width / 2);
    window.open(this.props.targetShareUrl, 'share', 'width=' + width + ', height=' + height + ',left='+leftpx+',top='+toppx);
  }
}

ShareableSocialIcon.propTypes = {
  targetShareUrl: PropTypes.string.isRequired
};


const ShareableFacebookIcon = (props) => {
  const linkToShare = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(props.shareUrl);
  return (
    <ShareableSocialIcon targetShareUrl={linkToShare} className="share-facebook-icon">
      <FacebookIcon/>
    </ShareableSocialIcon>
  );
};

const ShareableTwitterIcon = (props) => {
  const linkToShare = 'http://www.twitter.com/intent/tweet?url=' +
    encodeURIComponent(props.shareUrl) +
    '&text=We+just+created+a+%40Zoomforth+site.+Check+it+out%3A';
  return (
    <ShareableSocialIcon targetShareUrl={linkToShare} className="share-twitter-icon">
      <TwitterIcon/>
    </ShareableSocialIcon>
  );
};

const ShareableLinkedInIcon = (props) => {
  const linkToShare = 'https://www.linkedin.com/shareArticle?url=' +
    encodeURIComponent(props.shareUrl) +
    '&mini=true&source=Zoomforth&title=We%E2%80%99re+excited+to+share+our+personalized+Zoomforth+site.+Check+it+out%21';
  return (
    <ShareableSocialIcon targetShareUrl={linkToShare} className="share-linkedin-icon">
      <LinkedInIcon/>
    </ShareableSocialIcon>
  );
};

export default ShareableSocialIcon;

export { ShareableFacebookIcon, ShareableTwitterIcon, ShareableLinkedInIcon };
